import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'app-general-table',
	templateUrl: './general-table.component.html'
})
export class GeneralTableComponent implements OnInit {
	@Input() encabezado;
	@Input() contenido;
	dataTable: any;
	constructor() { }

	ngOnInit(): void {
		console.log(this.contenido);
	}
}
